// import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation } from '@tanstack/react-query';
import { PaymentApi } from 'api';
import type { Payment } from 'api/methods/PaymentApi';

/**
 * [Payment] 카드 결제 취소
 * --
 */
export const usePaymentCancelCard = () => {
  const { mutateAsync: cancelCard, ...result } = useMutation({
    mutationFn: (variables: Payment) => PaymentApi.paymentCancelCard(variables),
  });

  return { cancelCard, ...result };
};

/**
 * [Payment] 계좌이체 취소
 * --
 */
export const usePaymentCancelAccount = () => {
  const { mutateAsync: cancelAccount, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentCancelAccount(variables),
  });

  return { cancelAccount, ...result };
};

/**
 * [Payment] 휴대폰결제 취소
 * --
 */
export const usePaymentCancelMobile = () => {
  const { mutateAsync: cancelMobile, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentCancelMobile(variables),
  });

  return { cancelMobile, ...result };
};

/**
 * [Payment] 일회성 가상계좌 발급
 * --
 */
export const usePaymentIssueVaccount = () => {
  const { mutateAsync: issueVaccount, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentIssueOnetimeVaccount(variables),
  });

  return { issueVaccount, ...result };
};

/**
 * [Payment] 가상계좌 회수
 * --
 */
export const usePaymentRecallVaccount = () => {
  const { mutateAsync: recallVaccount, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentRecallVaccount(variables),
  });

  return { recallVaccount, ...result };
};

/**
 * [Payment] 현금영수증 발급
 * --
 */
export const usePaymentIssueCashbill = () => {
  const { mutateAsync: issueCashbill, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentIssueCashbill(variables),
  });

  return { issueCashbill, ...result };
};

/**
 * [Payment] 현금영수증 발급 취소
 * --
 */
export const usePaymentCancelCashbill = () => {
  const { mutateAsync: cancelCashbill, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentCancelCashbill(variables),
  });

  return { cancelCashbill, ...result };
};

/**
 * [Payment] 빌링카드 등록
 * --
 */
export const usePaymentRegistBilling = () => {
  const { mutateAsync: registBilling, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentRegistBilling(variables),
  });

  return { registBilling, ...result };
};

/**
 * [Payment] 빌링카드 등록 조회
 * --
 */
export const usePaymentQueryBilling = () => {
  const { mutateAsync: queryBilling, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentQueryBilling(variables),
  });

  return { queryBilling, ...result };
};

/**
 * [Payment] 빌링카드 등록 취소
 * --
 */
export const usePaymentDeRegistBilling = () => {
  const { mutateAsync: deregistBilling, ...result } = useMutation({
    mutationFn: (variables: Payment) =>
      PaymentApi.paymentDeRegistBilling(variables),
  });

  return { deregistBilling, ...result };
};

/**
 * [Payment] 빌링카드 등록
 * --
 */
export const usePaymentPayBilling = () => {
  const { mutateAsync: payBilling, ...result } = useMutation({
    mutationFn: (variables: Payment) => PaymentApi.paymentPayBilling(variables),
  });

  return { payBilling, ...result };
};
